import axios from "../../service/index"
import React, { Component } from "react"
import {Form, Input, Select, Divider, message, Icon, Switch, Button} from 'antd'
import UploadQiniu from '../../commponents/uploadQiniu/index'
import UploadVideo from '../../commponents/video/index'
import Wangeditor from '../../commponents/wangeditor/index'
import "./openclass.less"
const FormItem = Form.Item;
const {Option} = Select;
class createVocation extends Component{
  constructor(props) {
		super(props)
    this.state = {
      modelTitle: '新建',
      subjectIcon: '',
      clickUrl: '',
      optionList: [],
      courseUrl: '',
      qiuniuUrl: '',
      url: '',
      queryId: '',
      subjectId: '',
      isEdit: true,
      detailInfo: {},
      type: 0,
      qiniuVideo: '',
      isIntroduct: true,
      persistentId: '',
      isoutline: true,
      isresearch: true,
      isExperience: true,
      studyVideo: null,
      introductionContent: '',
      outlineContent: '',
      researchTeamContent: '',
      studyExperienceContent: '',
    }
  }
  componentDidMount() {
    this.getToken()
    this.subjectList()
    this.props.form.setFieldsValue({
			'publish': false
		})
    if(this.props.location.state?.id){
      this.setState({queryId: this.props.location.state.id, modelTitle: '编辑'}, () => {
        this.getInfo()
      })
    }
  }
  subjectList = () => {
    axios.get(`subjectController/subjects/2`).then(res => {
      if(res.data.code === '200'){
        this.setState({optionList: res.data.data})
      }else{
        message.error(res.data.msg)
      }
    })
  }
  handleOk = (e) => {
    e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
        let imgfileUrl = ''
        let videofileUrl = ''
        let fileName = ''
        let persistentId = ''
        if(values.type === 0){
          videofileUrl = (values.studyVideo.url&&this.state.modelTitle === '编辑')?values.studyVideo.url:values.studyVideo[0].response.zmBosUrl?this.state.url+'/'+values.studyVideo[0].response.zmBosUrl:this.state.url+'/'+values.studyVideo[0].response.key
          fileName = this.state.modelTitle === '新建'?values.studyVideo[0].name:values.studyVideo.name && values.studyVideo.name ? values.studyVideo.name : values.studyVideo[0].name
          persistentId = (values.studyVideo.url &&this.state.modelTitle === '编辑')?values.studyVideo.persistentId: values.studyVideo[0].response.persistentId
        }else if(values.type === 1){
          imgfileUrl = (values.courseUrl.url&&this.state.modelTitle === '编辑')?(values.courseUrl.url):(this.state.qiuniuUrl+'/'+values.courseUrl.response.key)
        }

        let params = {
          id: this.state.modelTitle === '编辑'?this.state.queryId:'',
          name: values.name,
          posterUrl: (values.posterUrl.url && this.state.modelTitle === '编辑')?values.posterUrl.url : this.state.qiuniuUrl+'/'+values.posterUrl.response.key,
          // md5Code: values.
          type: values.type,
          fileName: values.type ===0?fileName:values.name,
          publish: values.publish === false?0:1,
          fileUrl: values.type ===1? imgfileUrl:videofileUrl,
          persistentId: persistentId||'',
          subjectId: values.subjectId,
          introductionContent: values.introductionContent||'',
          outlineContent: values.outlineContent||'',
          researchTeamContent: values.researchTeamContent,
          studyExperienceContent: values.studyExperienceContent,
        }
        let url = this.state.modelTitle === '新建'?'/employmentcourse/add': 'employmentcourse/update'
        axios.post(url, params).then(res => {
          if(res.data.code === '200'){
            message.success(this.state.modelTitle+'成功')
            this.props.form.resetFields()
            localStorage.setItem('type', 'vocat')
            this.props.history.push('/subjectController')
            
          }else{
            message.error(res.data.msg)
          }
        })
      }
    })
  }
  getInfo = () => {
    axios.get(`employmentcourse/info/${this.state.queryId}`).then(res => {
      // console.log(res.data.data)
      if(res.data.code === '200'){
        this.setState({
          type: res.data.data.type,
          detailInfo: res.data.data,
          subjectId: res.data.data.subjectId,
          introductionContent: res.data.data.introductionContent,
          outlineContent: res.data.data.outlineContent,
          researchTeamContent: res.data.data.researchTeamContent,
          studyExperienceContent: res.data.data.studyExperienceContent,
          subjectIcon: {
            uid: null,
            type: null,
            url: res.data.data.posterUrl,
            name: res.data.data.name
          },
          studyVideo: res.data.data.type === 0?{
            uid: null,
            url: res.data.data.fileUrl,
            name: res.data.data.fileName,
            type: 'video/*',
            persistentId: res.data.data.persistentId
          }: {},
          courseUrl: res.data.data.type === 1?{
            uid: null,
            type: null,
            url: res.data.data.fileUrl,
            name:res.data.data.name
          }:{},
        }, () => {
          this.props.form.setFieldsValue({
            'publish': res.data.data.publish === 0 ? false : true,
            'subjectId': res.data.data.subjectId,
            'introductionContent': res.data.data.introductionContent,
            'outlineContent': res.data.data.outlineContent,
            'researchTeamContent': res.data.data.researchTeamContent,
            'studyExperienceContent': res.data.data.studyExperienceContent,
          })
        })
        
      }else{
        message.error(res.data.msg)
      }
    })
  }
  
  getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
  componentWillUnmount() {
    this.setState = () => false;
 }
  getQiniuUrl = (v) => {
    this.setState({
			qiuniuUrl: v
		})
  }
  getQiniuUrl1 = v => {
  }
  getText = (v, i) => {
		this.props.form.setFieldsValue({
      [`${i}`]: v
		});
	}
  render() {
    const {modelTitle, subjectIcon, type, introductionContent, isoutline, isresearch, isExperience, studyExperienceContent, outlineContent, detailInfo, researchTeamContent, isIntroduct, courseUrl, studyVideo} = this.state
    const { getFieldDecorator } = this.props.form;
    return (
        <div className="create-subject">
          <div className="header-between">
          <span className="header-name">{modelTitle}就业课程</span>
          <span className="my-button-txt" onClick={()=>{
              this.props.history.push('/subjectController')
              localStorage.setItem('type', 'vocat')
            }}>返回上一级</span>
          </div>
          <Divider />
          <Form labelCol={{ span: 3 }} wrapperCol={{ span: 12 }} onSubmit={this.handleOk}>
            <FormItem label={"课程名称"} key={0}>
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '请输入课程名称!', }],
                initialValue:modelTitle==='编辑'? detailInfo.name: ''
              })(
                <Input placeholder='请输入课程名称' allowClear maxLength={50}/>
              )}
            </FormItem>
            <Form.Item label="课程封面" className="posterUrl" key={6}>
              {getFieldDecorator('posterUrl', {
                initialValue: modelTitle==='编辑'? subjectIcon: '',
                rules: [{ type: 'object', required: true, message: '请上传课程封面!' }],
              })(
                  <UploadQiniu getQiniuUrl ={this.getQiniuUrl } />
              )}
            </Form.Item>
            <FormItem label={"导学资源"}>
              {getFieldDecorator('type', {
                rules: [{ required: true, message: '请选择导学资源!' }],
                initialValue:modelTitle==='编辑'? detailInfo.type: 0
              })(
                <Select style={{width: "200px"}} onChange={(val) => { this.setState({ type: val }) }} placeholder="请选择" className="zip-width">
                  <Option value={0} key={0}>视频</Option>
                  <Option value={1} key={1}>图片</Option>
                </Select>
              )}
            </FormItem>
            {((this.state.modelTitle === '新建'&&type===0)||(this.state.modelTitle === '编辑'&&type===0&&studyVideo))? <FormItem label="" style={{paddingLeft: '12.5%'}}>
              {getFieldDecorator('studyVideo', {
                rules: [{ required: true, message: '请上传视频!', }],
                initialValue:(modelTitle === '编辑'&&studyVideo.url)? studyVideo: ''
              })(
                  <UploadVideo checksType={'pass'} getQiniuUrl={this.getQiniuUrl1}></UploadVideo>
							  )
              }
            </FormItem>:''}
            {((this.state.modelTitle === '新建'&&type===1)||(this.state.modelTitle === '编辑'&&type === 1&&courseUrl))?<FormItem label="" style={{marginLeft: '12.5%'}}>
              {getFieldDecorator('courseUrl',{
                rules: [{ required: true, message: '请上传图片'}],
                initialValue:(modelTitle==='编辑'&&courseUrl.url)?courseUrl:''
              })(
                <UploadQiniu getQiniuUrl ={this.getQiniuUrl } />
              )}
            </FormItem>:''}
            <Form.Item label="所属学科">
              {getFieldDecorator('subjectId', {
                rules: [{ required: true, message: '请选择所属学科' }],
                initialValue:modelTitle === '编辑'? detailInfo.subjectId: ''
              })(
                <div className="form-item-flex">
                  <Select
                    value={this.state.subjectId}
                    placeholder="请选择所属学科"
                    onChange={(e) => {this.setState({subjectId: e});this.props.form.setFieldsValue({'subjectId': e})}}
                    style={{width: "200px",marginRight: '20px'}}
                  >
                    {this.state.optionList.map(item=>{
                      return (<Option key={item.subjectId+item.subjectName} value={item.subjectId}>{item.subjectName}</Option>)
                    })}
                  </Select>
                  <p>选择学科后，小程序端【就业课】按钮跳转到对应学科的列表页</p>
                </div>
              )}
            </Form.Item>
            <p className="zip-title"><span className="title">课程详情配置: </span><span>每个模块内容需要单独配置，内容配置完整后小程序的课程详情页菜单及对应内容才会展示</span></p>
            <div>
            <FormItem label="课程介绍">
              {getFieldDecorator('introductionContent', {
                initialValue:modelTitle==='编辑'? introductionContent: ''
              })(
                <div>
                  <p className="readonly-text" onClick={() => {this.setState({isIntroduct: !this.state.isIntroduct})}}>{isIntroduct?'展开':'收起'}{isIntroduct?<Icon type="caret-down" />:<Icon type="caret-up" />}</p>
                  {isIntroduct?'':<Wangeditor content={introductionContent} getText={(e) => this.getText(e, 'introductionContent')} />}
                </div>
              )}
            </FormItem>
            <FormItem label="课程大纲">
              {getFieldDecorator('outlineContent', {
                initialValue:modelTitle==='编辑'? outlineContent: ''
              })(
                <div>
                  <p className="readonly-text" onClick={() => {this.setState({isoutline: !this.state.isoutline})}}>{isIntroduct?'展开':'收起'}{isoutline?<Icon type="caret-down" />:<Icon type="caret-up" />}</p>

                  {isoutline?'':<Wangeditor content={outlineContent} getText={(e) => this.getText(e, 'outlineContent')} />}
                </div>
              )}
            </FormItem>
            <FormItem label="教研团队">
              {getFieldDecorator('researchTeamContent', {
                initialValue:modelTitle==='编辑'? researchTeamContent: ''
              })(
                <div>
                  <p className="readonly-text" onClick={() => {this.setState({isresearch: !this.state.isresearch})}}>{isresearch?'展开':'收起'}{isresearch?<Icon type="caret-down" />:<Icon type="caret-up" />}</p>

                  {isresearch?'':<Wangeditor content={researchTeamContent} getText={(e) => this.getText(e, 'researchTeamContent')} />}
                </div>
              )}
            </FormItem>
            <FormItem label="学习经历">
              {getFieldDecorator('studyExperienceContent', {
                initialValue:modelTitle==='编辑'? studyExperienceContent: ''
              })(
                <div>
                  <p className="readonly-text" onClick={() => {this.setState({isExperience: !this.state.isExperience})}}>{isIntroduct?'展开':'收起'}{isExperience?<Icon type="caret-down" />:<Icon type="caret-up" />}</p>

                  {isExperience?'':<Wangeditor content={studyExperienceContent} getText={(e) => this.getText(e, 'studyExperienceContent')} />}
                </div>
              )}
            </FormItem>
            </div>
            <FormItem label={"发布课程"}>
              {getFieldDecorator('publish', {
                valuePropName: 'checked'
              })(
                // <div>
                  <Switch  />
                //   <span style={{marginLeft: '20px'}}>课程发布后用户端可见</span>
                // </div>
              )}
            </FormItem>
            <FormItem>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<Button style={{ marginRight: '30px' }} onClick={() => {
								this.props.history.push('/subjectController')
                localStorage.setItem('type', 'vocat')
							}}>取消</Button>
							<Button type="primary" htmlType="submit">确定</Button>
						</div>
            </FormItem>
          </Form>
        </div>
    )
  }
}
export default Form.create()(createVocation)